// extracted by mini-css-extract-plugin
export default {"actions":"PopUpForm_actions__cPqoL","form":"PopUpForm_form__5Qgt0"};